import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaChevronDown } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OnePatient from '../ones/OnePatient';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import PatientRegistrationForm from "../ones/PatientRegistrationForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);	

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		//await appContext.getAllPatients();
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allPatients])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							Patients
						</h6>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<h6
									className="sub-section-title"
								>
									Patient Statistics
								</h6>
								<hr/>

								<div className="row">
									<div className="col-6 col-md-3 mt-2 mb-2">
										<div className="card">
											<div className="card-body text-center">
												<h6
													className="mNoMargin"
													style={{
														fontSize: "14px",
													}}
												>
													Today
												</h6>

												<h4
													className="mNoMargin text-primary mt-2"
												>
													0
												</h4>
											</div>
										</div>
									</div>

									<div className="col-6 col-md-3 mt-2 mb-2">
										<div className="card">
											<div className="card-body text-center">
												<h6
													className="mNoMargin"
													style={{
														fontSize: "14px",
													}}
												>
													This Week
												</h6>

												<h4
													className="mNoMargin text-primary mt-2"
												>
													0
												</h4>
											</div>
										</div>
									</div>

									<div className="col-6 col-md-3 mt-2 mb-2">
										<div className="card">
											<div className="card-body text-center">
												<h6
													className="mNoMargin"
													style={{
														fontSize: "14px",
													}}
												>
													This Month
												</h6>

												<h4
													className="mNoMargin text-primary mt-2"
												>
													0
												</h4>
											</div>
										</div>
									</div>

									<div className="col-6 col-md-3 mt-2 mb-2">
										<div className="card">
											<div className="card-body text-center">
												<h6
													className="mNoMargin"
													style={{
														fontSize: "14px",
													}}
												>
													All Time
												</h6>

												<h4
													className="mNoMargin text-primary mt-2"
												>
													0
												</h4>
											</div>
										</div>
									</div>
								</div>
								
							</div>
						</div>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<div
									className="d-flex justify-content-between"
									style={{ cursor: "pointer" }}
									data-bs-toggle="collapse"
									data-bs-target="#_patientsSection1"
									aria-expanded="false"
									aria-controls="_patientsSection1"
								>
									<h6
										className="sub-section-title align-self-center"
									>
										Register New Patient
									</h6>

									<FaChevronDown size={24} className="align-self-center text-primary" />
								</div>
								
								<div className="collapse" id="_patientsSection1">
									<hr/>

									<PatientRegistrationForm/>
								</div>
								
							</div>
						</div>
					</div>

					<div className="col-md-12" id="_coinsOrdersList">
						<div
							className="card"
						>
							<div className="card-body">

								<div className="d-flex justify-content-between mb-4">

									<h6
										className="sub-section-title"
										
									>
										All Patients
									</h6>

									<input
										className="form-control mNoMargin align-self-center"
										style={{
											width: "150px"
										}}
										onChange={(e) => setSearchFilter(e.target.value)}
										placeholder="Filter by name"
									/>

								</div>
								<hr/>

								{
									(appContext.allPatients && appContext.allPatients.length > 0) ?
										appContext.allPatients.map((item, i) => {
											if (searchFilter) {
												if (
													String(item.name).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 
												) {
													return (
														<OnePatient data={item} key={i} />
													)
												} else {
													return "";
												}
											} else {
												return (
													<OnePatient data={item} key={i} />
												)
											}
										})
										:
										<h6
											className=""
											style={{
												fontSize: "14px",
											}}
										>
											No patient was found
										</h6>
								}
							</div>

						</div>
					</div>

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}